export default "__VITE_ASSET__CHfuM_RG__"